<template>
  <input
      class="form-control form-control-sm text-end"
      ref="inputRef"
      type="text"
      @keydown.enter.prevent="$emit('enter', $event)"
      @keydown.up.prevent="handleArrowUp"
      @keydown.down.prevent="handleArrowDown"
      @focus="onFocus"
  />
</template>

<script>
import { watch } from 'vue' // Vue 2: import { watch } from '@vue/composition-api'
import { useCurrencyInput } from 'vue-currency-input'

export default {
  name: 'CurrencyInput',
  emits: ['enter', 'update:modelValue'],
  props: {
    modelValue: Number, // Vue 2: value
    options: Object
  },
  setup(props, { emit }) {
    const { inputRef, setOptions, setValue } = useCurrencyInput(props.options)

    const updateAmount = (delta, event = null) => {
      const currentValue = Number(props.modelValue || 0)
      const newValue = Math.max(0, currentValue + delta)

      emit('update:modelValue', newValue)
      setValue(newValue)
      if(event) event.target.select()
    }

    const handleArrowUp = (event) => {
      if (event.ctrlKey) {
        updateAmount(10, event)
      } else if (event.shiftKey) {
        updateAmount(100, event)
      }
      else{
        updateAmount(1, event)
      }
    }

    const handleArrowDown = (event) => {
      if (event.ctrlKey) {
        updateAmount(-10, event)
      } else if (event.shiftKey) {
        updateAmount(-100, event)
      }
      else{
        updateAmount(-1, event)
      }

    }

    const onFocus = (event) => {
      //if (!mouseDown) {
        event.target.select()
      //}

      //setTimeout(() => {
      //  mouseDown = false
      //}, 0)
    }

    watch(
        () => props.modelValue, // Vue 2: props.value
        (value) => {
          setValue(value)
        }
    )

    watch(
        () => props.options,
        (options) => {
          setOptions(options)
        }
    )

    return {
      inputRef,
      handleArrowUp,
      handleArrowDown,
      onFocus
    }
  }
}
</script>